module.exports = __webpack_public_path__ + "img/ml3022.a15920c1.png";